import { drawing as d } from '@progress/kendo-drawing';
import { Group } from './Group';
import { toDrawingRect } from './utils';
import { Rect } from './../math';
import { deepExtend } from './../utils/deep-extend';
/**
 * Represents a layout container that automatically arranges child elements.
 * Extends Group to provide automatic layout and positioning capabilities.
 */
export class Layout extends Group {
    /**
     * Creates a new Layout instance.
     * @param rect The rectangle bounds for the layout
     * @param options Configuration options for the layout
     */
    constructor(rect, options) {
        super(options);
        this.drawingElement = new d.Layout(toDrawingRect(rect), options);
        this._initSize();
    }
    /**
     * Gets or sets the rectangle bounds of the layout.
     * @param rect The rectangle bounds to set, or undefined to get current bounds
     * @returns The current rectangle bounds when called as getter
     */
    rect(rect) {
        if (rect) {
            this.drawingElement.rect(toDrawingRect(rect));
        }
        else {
            const drawingRect = this.drawingElement.rect();
            if (drawingRect) {
                return new Rect(drawingRect.origin.x, drawingRect.origin.y, drawingRect.size.width, drawingRect.size.height);
            }
        }
    }
    /**
     * Triggers a reflow of the layout, recalculating positions and sizes.
     */
    reflow() {
        this.drawingElement.reflow();
    }
    /**
     * Redraws the layout with updated options.
     * @param options New options to apply to the layout
     */
    redraw(options) {
        deepExtend(this.drawingElement.options, options);
        super.redraw.call(this, options);
    }
}
